import type { TrackingFn } from '@change-corgi/core/react/tracking';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { GenerateAiDraft } from './api.graphql';
import type { GenerateAiDraftMutation, GenerateAiDraftMutationVariables } from './api.graphql';

type Input = { mainPrompt: string; personalStory?: string; locationName?: string };

type GenerateAiDescriptionReturn = { ask: string; description: string };
export async function generateAiDraft(
	input: Input,
	{ gql: { fetch } }: UtilityContext,
	track: TrackingFn,
): Promise<GenerateAiDescriptionReturn> {
	void track('sap_ai_draft_generate');

	try {
		const { data } = await fetch<GenerateAiDraftMutation, GenerateAiDraftMutationVariables>({
			query: GenerateAiDraft,
			variables: { input },
			rejectOnError: true,
		});

		if (data.generateAiDraft.__typename === 'GenerateAiDraftError') throw Error(data.generateAiDraft.reason);

		void track('sap_ai_draft_generate_loaded');

		const recommendedDraft = {
			ask: data.generateAiDraft.ask,
			// description is sanitized of HTML in the backend
			// but we want to preserve line breaks as HTML when saving this value to the database
			// necessary for when the description is not passed through a rich text editor
			description: data.generateAiDraft.description.replaceAll('\n', '<br>'),
		};

		return recommendedDraft;
	} catch (e: unknown) {
		void track('sap_ai_draft_generate_error');

		throw new Error('SAP: Failed to generate AI description', { cause: e });
	}
}
